
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421" viewBox="0 0 625 625"><path d="M213.173-664.653h621.32v597.846h-621.32z" style="fill:none" transform="matrix(1.00592 0 0 1.04542 -214.436 694.84)"/><path d="M48.055 593.004c255.301 25.307 460.302-125.705 511.439-190.41 51.137-64.708-26.402-373.428-26.402-373.428C449.042 235.65 296.222 548.6 48.055 593.108v-.104Z"/><path d="M37 101.951c31.891 1.174 56.165-18.88 62.017-27.194C104.868 66.444 95.909 29 95.909 29 87.046 54.938 62.387 92.735 37 101.951Z" style="fill:#3d3d3d" transform="matrix(4.72221 0 0 4.72222 -8.612 29.166)"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    